// Both the character name and its saved palette select this exclusive appearance.
export const TOONZA_NEON_COLORS = ['#38f9ff', '#6bb8ff', '#b084ff', '#fa66ff', '#ff87d5', '#5cffe0'];
export function hasExclusiveNeon(name: string, colors?: string[], earnedNeon = false) {
  return earnedNeon === true || (name === 'ToonZa' && colors?.length === TOONZA_NEON_COLORS.length &&
    TOONZA_NEON_COLORS.every((color, index) => colors[index]?.toLowerCase() === color));
}
